import { render, staticRenderFns } from "./Cadastro.vue?vue&type=template&id=7752cc44&scoped=true"
import script from "./Cadastro.vue?vue&type=script&lang=ts"
export * from "./Cadastro.vue?vue&type=script&lang=ts"
import style0 from "./Cadastro.vue?vue&type=style&index=0&id=7752cc44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7752cc44",
  null
  
)

export default component.exports